import { styled } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import './index.scss';

import { Text } from "../../shared/uiComponents";
import { BACKGROUND } from "../../shared/Helpers/colors";
import { AdminTypes } from "../../components/Menu";
import { Loader } from "../../components/StyledComponents";
import BCBA from "./BCBA";
import Admin from "./Admin";
import ClinicalSupervisor from "./CS";
import BT from "./BT";
// import DesignInfo from "./DesignInfo";

import { useSelector } from '../../redux/store';

export const Containerr = styled('div')(() => ({
	backgroundColor: BACKGROUND.PRIMARY[100],
	width: '100%',
	padding: '24px',
	borderRadius: '12px',
	minWidth: '720px',
	maxWidth: '1440px',
	display: 'flex',
	alignItems: 'center',
	flexDirection: 'column',
	'>div': {
		width: 'max-content',
	},
	'@media (max-width: 768px)': {
		minWidth: '220px',
		padding: '8px',
	},
}));

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
};

const Dashboard = () => {
  const [searchParams] = useSearchParams();
  const loadingAccount = useSelector((state) => state.account.loading);
  const role = useSelector((state) => state.account.role);
  const isAdmin = AdminTypes.admin === role?.section.id;
  const isBt = AdminTypes.bt === role?.section.id;
  const showCsDashboard = isAdmin && searchParams.has('show-cs-dashboard');
  const firstName = useSelector((state) => state.account.user.firstName);

  return (
    <>
      {/* <DesignInfo /> */}
      <div className="welcomeHeader">
        <Text
          title={firstName ? `${getGreeting()}, ${firstName}` : getGreeting()}
          type="h2"
          font="header"
          fontWeight="semiBold"
        />
        <Text
          title={new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
          type="psm"
          className="welcomeDate"
        />
      </div>
      {isAdmin && !showCsDashboard && <Admin />}
      {isAdmin && showCsDashboard && <ClinicalSupervisor />}
      {AdminTypes.bcba === role?.section.id && <BCBA />}
      {isBt && <BT />}
      {AdminTypes.cs === role?.section.id && <ClinicalSupervisor />}
      {loadingAccount && <Loader />}
    </>
  );
};

export default Dashboard;
